import React, { useState, useRef, useMemo } from 'react';
import Slider from 'react-slick';
import { Drawer } from 'antd';
import ShareLike from '../ShareLike/ShareLike';
import { ArrowLeft, Gallery } from '../../assets/icons';
import PropertySlickSlider from './PropertySlickSlider';
import { useSelector } from 'react-redux';
import useMediaQuery from '../../Hooks/useMediaQuery';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Images } from '../../config/images';

const PropertySlider = (props) => {
  const slider = useRef();
  const isMD = useMediaQuery('(min-width: 1000px)');

  const [galleryOpen, setGalleryOpen] = useState(false);
  const [sliderOpen, setSliderOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const {
    loading = false,
    data: { data: { images = {}, tag = '', name = '' } = {} },
  } = useSelector((state) => state.propertyDetails);

  const handleClick = (index) => {
    setSliderOpen(true);
    setIndex(index);
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
    afterChange: (firstArgument) => setIndex(firstArgument),
  };
  const imagesData = useMemo(() => {
    const imagesArr = [];
    const primaryImage = images?.primaryImage;
    if (Object.keys(images).length) {
      if (images?.[primaryImage]) {
        imagesArr.push(images?.[primaryImage]);
      }
      Object.keys(images).forEach((key) => {
        if (key !== primaryImage && key !== 'primaryImage') {
          imagesArr.push(images?.[key]);
        }
      });
    }
    return imagesArr.filter(Boolean);
  }, [images]);

  return (
    <div className='container-fluid property-container'>
      {isMD ? (
        <div className='property-slider--desktop'>
          <span className={`prop-label ${props.type}`}>{tag}</span>
          <div className='property-slider--desktop__images'>
            {!loading &&
              React.Children.toArray(
                imagesData
                  .map((image, i) => (
                    <LazyLoadImage
                      onError={(element) => {
                        element.target.src = Images.noPropertyFoundImage;
                      }}
                      src={image}
                      alt={`property ${i}`}
                    />
                  ))
                  .filter((_, i) => i < 4)
              )}
          </div>
          <p className='viewall' onClick={() => setGalleryOpen(true)}>
            <Gallery size={20} />
            View all
          </p>
        </div>
      ) : (
        <div className='property-slider--mobile' onClick={() => setGalleryOpen(true)}>
          <span className={`prop-label ${props.type}`}>{tag}</span>
          <Slider initialSlide={index} {...settings}>
            {React.Children.toArray(
              imagesData.map((src, id) => (
                <div className='mobile-slide'>
                  <LazyLoadImage
                    onError={(element) => {
                      element.target.src = Images.noPropertyFoundImage;
                    }}
                    alt={`Property ${id}`}
                    src={src}
                  />
                </div>
              ))
            )}
          </Slider>
          <div className='property-slider--mobile__numbers'>
            {index + 1} / {imagesData.length}
          </div>
        </div>
      )}
      {galleryOpen && (
        <Drawer
          open={galleryOpen}
          className='gallery-drawer'
          onClose={() => setGalleryOpen(false)}
          width='100%'
          headerStyle={{ display: 'none' }}
          footer={false}
        >
          <div className='d-flex align-items-center justify-content-space-between gallery-head'>
            <div className='d-flex'>
              <ArrowLeft className='cursor-pointer' size={24} marginRight='8px' onClick={() => setGalleryOpen(false)} />
              <span className='fw-600 fz-16 d-sm'>{name}</span>
            </div>
            <ShareLike className='small-font' />
          </div>
          <div className='property-gallery pb-32'>
            {
              imagesData.map((item, id) => (
                <LazyLoadImage
                  key={id}
                  onError={(element) => {
                    element.target.src = Images.noPropertyFoundImage;
                  }}
                  visibleByDefault
                  onClick={() => handleClick(id)}
                  alt={`property ${id}`}
                  src={item}
                  style={{ width: '100%' }}
                />
              ))
            }
          </div>
        </Drawer>
      )}

      {sliderOpen && (
        <PropertySlickSlider
          ref={slider}
          setIndex={setIndex}
          index={index}
          sliderOpen={sliderOpen}
          setSliderOpen={setSliderOpen}
          images={imagesData}
        />
      )}
    </div>
  );
};

export default PropertySlider;
